// @ts-ignore -- "FirebaseUtils" is resolved by the web bundler, not by tsc
import {functions, httpsCallableCustom} from "FirebaseUtils";
import LogService from "services/LogService.js";
import {unwrapCallableResponse} from "services/wsdbUnwrap.js";

export interface RefreshSubscriptionResult {
  success: boolean;
  subscription?: any;
  error?: any;
}

/**
 * Subscription Service
 * Handles subscription-related operations including refreshing from Adapty
 */

/**
 * Refresh subscription data from Adapty
 * Fetches the latest subscription status from Adapty and updates Firebase
 * @return {Promise<Object>} Object with success status and subscription data
 */
export const refreshSubscriptionFromAdapty = async (): Promise<RefreshSubscriptionResult> => {
  try {
    // httpsCallableCustom routes through the native plugin on Android, where this is
    // now called from too.
    const refreshSubscription = httpsCallableCustom(functions, "refreshSubscription");
    // The handler only reads the caller's uid; the native transport wants an object.
    const payload = unwrapCallableResponse(await refreshSubscription({}));

    if (payload.success) {
      console.log("Successfully refreshed subscription from Adapty:", payload.subscription);
      return {
        success: true,
        subscription: payload.subscription
      };
    } else {
      LogService.addErrorLogAsync("", "Failed to refresh subscription from Adapty: " + payload.error, "", false, true);
      return {
        success: false,
        error: payload.error
      };
    }
  } catch (error) {
    LogService.addErrorLogAsync("", "Error calling refreshSubscription function: ", error.message, false, true);
    return {
      success: false,
      error: error.message
    };
  }
};

const SubscriptionService = {
  refreshSubscriptionFromAdapty
};

export default SubscriptionService;
